module.exports = __webpack_public_path__ + "static/media/relay-setting.14481033.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/relay-setting.png
// module id = 570
// module chunks = 6